import axios from "axios";

var baseURL = "https://www.falksteintabelle.de";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.falksteintabelle.de"
) {
  baseURL = "https://loc.falksteintabelle.de";
}

if (window.location.hostname == "/www.falksteintabelle.de") {
  baseURL = "https:///www.falksteintabelle.de";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    // Authorization: "sdZdfcaeqwsc9jsd189asddsa219275asmygvlwdsjasd9a", // Achte auf das Leerzeichen nach 'Bearer'
    "Content-Type": "application/json",
  },
});

export default http;
